import { render, staticRenderFns } from "./productsView.vue?vue&type=template&id=03a1a27d&scoped=true"
import script from "./productsView.vue?vue&type=script&lang=js"
export * from "./productsView.vue?vue&type=script&lang=js"
import style0 from "./productsView.vue?vue&type=style&index=0&id=03a1a27d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a1a27d",
  null
  
)

export default component.exports